<div *ngIf="sittings && sittings.length > 0">
    <ul class="list-group sitting-selection">
        <li
            class="list-group-item"
            [ngClass]="{selected: sitting.id === selectedSittingId, private: isPrivate === true}"
            *ngFor="let sitting of sittings"
            [attr.data-qa]="sitting.siteCode"
            (click)="onSelect(sitting)"
        >
            <div class="list-group-item-text row">
                <div class="col-md-8">
                    <strong *ngIf="!webDelivery">{{sitting.testDateTimeTestCentre | customDate: 'sittingsFormatDateTime'}}</strong>
                    <strong *ngIf="webDelivery">{{sitting.testDateTimeUtc | customDate: 'sittingsFormatDateTime'}}</strong>
                    <span
                        class="location"
                        *ngIf="webDelivery"
                    > (Time Zone: {{localTimeZone}}) </span>
                    <strong><span
                            *ngIf="sitting.id !== selectedSittingId"
                            class="promotion-info"
                        > &nbsp;&nbsp; {{sitting.promotionInfo}} </span></strong>
                    <br />
                    <p *ngIf="sitting.id === selectedSittingId"></p>
                    <span
                        class="location"
                        *ngIf="!webDelivery"
                    >{{sitting.testCentreName}} - {{sitting.testCentreCity}}</span>
                    <p
                        class="selected-sitting-detail"
                        *ngIf="!webDelivery && sitting.id === selectedSittingId"
                    >
                        <u>{{sitting.testCentreAddressLine1}}</u>
                        <u *ngIf="sitting.testCentreAddressLine2 && sitting.testCentreAddressLine2.length > 0">{{sitting.testCentreAddressLine2}}</u>
                        <u *ngIf="sitting.testCentreAddressLine3 && sitting.testCentreAddressLine3.length > 0">{{sitting.testCentreAddressLine3}}</u>
                        <u *ngIf="sitting.testCentreAddressLine4 && sitting.testCentreAddressLine4.length > 0">{{sitting.testCentreAddressLine4}}</u>
                        <u>{{sitting.testCentreCity}}, {{sitting.testCentreRegion}} <span *ngIf="sitting.testCentrePostalCode.length > 0">{{sitting.testCentrePostalCode}}</span></u>
                    </p>
                    <div
                        class="warning"
                        *ngIf="sitting.warningSeatCount && sitting.warningSeatCount !== 1"
                    >{{sitting.warningSeatCount}} seats left!</div>
                    <div
                        class="warning"
                        *ngIf="sitting.warningSeatCount && sitting.warningSeatCount === 1"
                    >{{sitting.warningSeatCount}} seat left!</div>
                </div>
                <div
                    class="selected-sitting col-md-4 align-self-end"
                    *ngIf="sitting.id === selectedSittingId && sitting.promotionInfo !== ''"
                >
                    <table style="align-items:center">
                        <tr>
                            <td><span class="promotion-info"> {{sitting.promotionInfo}} &nbsp;&nbsp;</span></td>
                            <td>
                                <a
                                    (click)="confirmSelect(sitting)"
                                    class="btn btn-warning"
                                >Select</a>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>&nbsp;&nbsp;<del class="promotion-info">{{sitting.testFee | currency: sitting.currencyCode : sitting.currencyCode + " "}}</del></td>
                        </tr>
                        <tr class="text-center">
                            <td></td>
                            <td>&nbsp;&nbsp;{{sitting.promotionTestFee | currency: sitting.currencyCode : sitting.currencyCode + " "}}</td>
                        </tr>
                    </table>
                </div>
                <div
                    class="selected-sitting col-md-4 align-self-end"
                    *ngIf="sitting.id === selectedSittingId && sitting.promotionInfo === '' "
                >
                    <div>
                        <button
                            type="button"
                            (click)="confirmSelect(sitting)"
                            class="btn btn-primary"
                        >Select</button></div>
                    <div>{{sitting.testFee | currency: sitting.currencyCode : sitting.currencyCode + " "}}
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>

<app-modal
    #warningSelectionModal
    title="{{warningModalTitle}}"
    body="{{warningModalBody}}"
    (clickPositive)="removeExistingSitting()"
    [isConfirm]="true"
>
</app-modal>
